export const bambeeBaseUrl = "/bambee/router";
